import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function PaymentResult({ success = true }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F8EDE2' }}>
      <Card className="max-w-md w-full p-8 text-center" data-testid="payment-result">
        {success ? (
          <>
            <CheckCircle2 className="h-14 w-14 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Директният дебит е настроен!</h1>
            <p className="text-slate-600">
              Благодарим ви. Мандатът за директен дебит е създаден успешно. Активирането по системата Bacs
              може да отнеме няколко работни дни. Ще получите имейл при всяко теглене на такса.
            </p>
          </>
        ) : (
          <>
            <XCircle className="h-14 w-14 text-slate-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Настройката е прекратена</h1>
            <p className="text-slate-600">
              Не беше настроен директен дебит. Можете да опитате отново по всяко време от панела.
            </p>
          </>
        )}
        <Button onClick={() => navigate('/')} className="mt-6 bg-[#00966E] hover:bg-[#007a59] text-white" data-testid="payment-result-home-btn">
          Към началото
        </Button>
      </Card>
    </div>
  );
}
